import * as QuestionModule from 'Modules/QuestionModule';
import { Question } from '../EnumTypes/ActionEnumTypes';

const init = () => ({
  type: Question.GET_QUESTIONS_BY_DEPARTMENT_INIT,
});

export const success = (data) => ({
  type: Question.GET_QUESTIONS_BY_DEPARTMENT_SUCCESS,
  payload: {
    data,
  },
});

const failure = () => ({
  type: Question.GET_QUESTIONS_BY_DEPARTMENT_FAILURE,
});

const getQuestionsByDepartment = (data) => async (dispatch) => {
  dispatch(init());
  try {
    const response = await QuestionModule.Connector.getQuestionsByDepartment(data);
    dispatch(success(response.data.question));
    return true;
  } catch (err) {
    dispatch(failure());
    return false;
  }
};

export default getQuestionsByDepartment;
